import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getConsent } from "@/components/CookieBanner";

const GA_ID = (process.env.REACT_APP_GOOGLE_ANALYTICS_ID || "").trim();

// GA4 is only loaded once the visitor accepts "Mesure d'audience" (CNIL).
function loadGa() {
  if (document.getElementById("ga4-src")) return;
  const s1 = document.createElement("script");
  s1.id = "ga4-src";
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s1);

  const s2 = document.createElement("script");
  s2.id = "ga4-init";
  s2.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', '${GA_ID}', { anonymize_ip: true });
  `;
  document.head.appendChild(s2);
}

export default function GoogleAnalytics() {
  const { pathname, search } = useLocation();

  // Une vue par page, y compris la première : PostHog est initialisé avec capture_pageview désactivé.
  useEffect(() => {
    let sent = false;
    const send = () => {
      if (sent || !window.posthog?.capture || !getConsent()?.analytics) return;
      sent = true;
      window.posthog.capture("$pageview", { $current_url: window.location.href });
    };
    send();
    window.addEventListener("vp-posthog-ready", send);
    return () => window.removeEventListener("vp-posthog-ready", send);
  }, [pathname, search]);

  useEffect(() => {
    if (!GA_ID) return;
    const check = () => {
      if (getConsent()?.analytics) {
        window[`ga-disable-${GA_ID}`] = false;
        loadGa();
      } else if (window.gtag) {
        window[`ga-disable-${GA_ID}`] = true;
        const domain = window.location.hostname.split(".").slice(-2).join(".");
        document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("_ga")).forEach((n) => {
          document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
          document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain}`;
        });
      }
    };
    check();
    window.addEventListener("vp-consent-updated", check);
    return () => window.removeEventListener("vp-consent-updated", check);
  }, []);

  return null;
}

export const GA_ENABLED = Boolean(GA_ID);
